import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getPromotions, getRecipes } from '../apis';
import { appGetLocale, appPathPrefix, isMobileAspectRatio } from '../helpers/appHelper';
import { useLocation, useNavigate } from 'react-router-dom';
import { yamazaki_brown } from '../styles/color';

const News = () => {
    const appLanguage = appGetLocale();
    const isEng = appLanguage === 'en';
    const [news, setNews] = useState([]);
    const [recipes, setRecipes] = useState([]);
    const [popupData, setPopupData] = useState(null);
    const [popupImageHeight, setPopupImageHeight] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const prefix = appPathPrefix();
    const isMobile = isMobileAspectRatio();

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('id');
        if (id) {
            const item = news.find(newsItem => newsItem.id === parseInt(id));
            if (item) {
                handleImageClick(item, false);
            }
        }
    }, [news, location.search]);

    useEffect(() => {
        if (popupData) {
            const imgElement = document.querySelector('.popup-image.show');
            if (imgElement) {
                imgElement.onload = () => {
                    setPopupImageHeight(imgElement.clientHeight);
                };
                setPopupImageHeight(imgElement.clientHeight);
            }
        }
    }, [popupData]);

    const getData = async () => {
        const [promotions_result, recipes_result] = await Promise.all([getPromotions(), getRecipes()]);
        if (!promotions_result.fail) {
            setNews(promotions_result);
        }
        if (!recipes_result.fail) {
            setRecipes(recipes_result);
        }
    }

    const handleImageClick = (item, updateUrl = true) => {
        setPopupData(item);
        if (updateUrl) {
            navigate(prefix + `/news?id=${item.id}`);
        }
    };

    const closePopup = () => {
        setPopupData(null);
        navigate(prefix + '/news');
    };

    const createMarkup = (html) => {
        return { __html: html };
    };

    const formatDescription = (description) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return description.replace(urlRegex, (url) => `<a href="${url}" target="_blank">${url}</a>`);
    };

    const NavBar = () => (
        <div className="news-nav">
            <a href={prefix + "/"} style={{ color: yamazaki_brown, textDecoration: 'none' }}>
                <span>
                    <FormattedMessage id={'menus.home'} />
                </span>
            </a>
            <span> {">"} </span>
            &nbsp;&nbsp;
            <span style={{ fontWeight: 'bold' }}>
                <FormattedMessage id={'menus.news'} />
            </span>
        </div>
    );

    const RecipesList = () => {
        const RecipesItem = () => {
            const recipesDate = (news_date) => {
                const date = new Date(news_date);
                const eng_format = date.toLocaleString(appLanguage, { month: "short" }) + ', ' + date.toLocaleString(appLanguage, { year: "numeric" });
                const chi_format = date.toLocaleString(appLanguage, { year: "numeric", month: "long" });
                return isEng ? eng_format : chi_format;
            }
            return (
                recipes.map((item, index) => (
                    isMobile ?
                        <div key={index}>
                            <div className="news-item-date">
                                <text>
                                    {recipesDate(item.datetime_str)}
                                </text>
                            </div>
                            <div className="news-item" key={index} onClick={() => window.open(item.web_image_url, '_blank')}>
                                <div className="news-item-image">
                                    <img src={item.web_thumbnail_url} />
                                </div>
                                <div className="news-item-title">
                                    <text>
                                        {item.title}
                                    </text>
                                </div>
                                <div className="news-item-desc" dangerouslySetInnerHTML={createMarkup(formatDescription(item.descript))} />
                            </div>
                        </div>
                        :
                        <div className="news-item" key={index} style={{ marginTop: (index === 0 || index === 1) ? "3vw" : "5vw" }} onClick={() => window.open(item.web_image_url, '_blank')}>
                            <div className="news-item-image">
                                <img src={item.web_thumbnail_url} />
                            </div>
                            <div className="news-item-title">
                                <text>
                                    {item.title}
                                </text>
                            </div>
                            <div className="news-item-desc" dangerouslySetInnerHTML={createMarkup(formatDescription(item.descript))} />
                        </div>
                ))
            );
        };

        return (
            <div className='news-container'>
                <RecipesItem />
            </div>
        );
    };

    const Title = () => {
        return (
            <div className='news-content-title-container'>
                {Array.from({ length: 18 }).map((_, index) => (
                    <span key={index} className="dot news_dot" />
                ))}
                <div className='news-content-title' style={{ letterSpacing: isEng?'0':'1vw' }}>
                    <FormattedMessage id={'news.contentTitle'} />
                </div>
                {Array.from({ length: 18 }).map((_, index) => (
                    <span key={index} className="dot news_dot" />
                ))}
            </div>
        )
    };

    const NewsList = () => {
        const NewsItem = () => {
            const newsDate = (news_date) => {
                const date = new Date(news_date);
                const eng_format = date.toLocaleString(appLanguage, { month: "short" }) + ', ' + date.toLocaleString(appLanguage, { year: "numeric" });
                const chi_format = date.toLocaleString(appLanguage, { year: "numeric", month: "long" });
                return isEng ? eng_format : chi_format;
            }
            return (
                news.map((item, index) => (
                    isMobile ?
                        <div key={index}>
                            <div className="news-item-date">
                                <text>
                                    {newsDate(item.datetime_str)}
                                </text>
                            </div>
                            <div className="news-item" key={index} onClick={() => handleImageClick(item)}>
                                <div className="news-item-image">
                                    <img src={item.web_thumbnail_url} />
                                </div>
                                <div className="news-item-title">
                                    <text>
                                        {item.title}
                                    </text>
                                </div>
                                <div className="news-item-desc" dangerouslySetInnerHTML={createMarkup(formatDescription(item.descript))} />
                            </div>
                        </div>
                        :
                        <div className="news-item" key={index} style={{ marginTop: (index === 0 || index === 1) ? "3vw" : "5vw" }} onClick={() => handleImageClick(item)}>
                            <div className="news-item-image">
                                <img src={item.web_thumbnail_url} />
                            </div>
                            <div className="news-item-title">
                                <text>
                                    {item.title}
                                </text>
                            </div>
                            <div className="news-item-desc" dangerouslySetInnerHTML={createMarkup(formatDescription(item.descript))} />
                        </div>
                ))
            );
        };

        return (
            <div className='news-container'>
                <NewsItem />
            </div>
        );
    }

    return (
        <div className='news'>
            <div className="news-background">
                <img src='./images/news_background.png' />
                <text className="news-title" style={{ letterSpacing: isEng?'0':'1.5vw' }}>
                    <FormattedMessage id={'news.title'} />
                </text>
            </div>
            <NavBar />
            <NewsList />
            <Title />
            <RecipesList />
            {popupData && (
                <>
                    <div className="popup-overlay show" onClick={closePopup} />
                    <div className='popup-container'>
                        <img src={popupData.web_image_url} className="popup-image show" onClick={closePopup} />
                        <div className="popup-text show" style={{ top: `calc(10% + ${popupImageHeight}px)` }}>
                            <text style={{ fontWeight: 'bold' }}>
                                {popupData.title}
                            </text>
                            <text dangerouslySetInnerHTML={createMarkup(formatDescription(popupData.descript))}>
                            </text>
                        </div>
                        {isMobile &&
                            <div className='popup-svg-close-btn' onClick={closePopup}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                    <g transform="translate(-277 -94)">
                                        <g transform="translate(277 94)" fill="none" stroke="#fff" strokeWidth="2">
                                            <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
                                            <circle cx="12.5" cy="12.5" r="11.5" fill="none" />
                                        </g>
                                        <g transform="translate(285.444 102.444)">
                                            <g>
                                                <path d="M0,0,7.975,7.975" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="3.5" />
                                                <path d="M7.975,0,0,7.975" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="3.5" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>}
                    </div>
                </>
            )}
        </div>
    )
};

export default News;